import { theme } from "../theme";

/**
 * Placeholder mark — a spotlight cone over a dot. Swap the SVG here and the
 * whole app follows; nothing else draws the logo.
 */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <svg width={size} height={size} viewBox="0 0 32 32" role="img" aria-label={theme.brand.name}>
        <defs>
          <linearGradient id="swyft-beam" x1="16" y1="2" x2="16" y2="30" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor={theme.colors.spot} stopOpacity="0.95" />
            <stop offset="1" stopColor={theme.colors.spot} stopOpacity="0.15" />
          </linearGradient>
        </defs>
        <path d="M16 3 L28 27 A13 13 0 0 1 4 27 Z" fill="url(#swyft-beam)" />
        <circle cx="16" cy="22" r="4.5" fill={theme.colors.gold} />
      </svg>
      <span className="font-display text-[0.95rem] font-extrabold tracking-tight text-chalk">
        {theme.brand.short}
      </span>
    </span>
  );
}
